export default __webpack_public_path__ + "static/media/79.ae72d7f1.svg";